import React, {createElement, useState, useEffect, useRef, useMemo} from 'react';
import Fuse from 'fuse.js';
import {useToggle, useEvent, get, useNamedSelector, useIntersection} from 'helpers';

export function useList(list, {deps = [], search, size = 20} = {}) {
  const [ isPrinting, togglePrinting ] = useToggle();
  const [ limit, setLimit ] = useState(size);

  useEvent('REDUX_UI_PRINT',  togglePrinting);
  useEvent('REDUX_UI_PRINT_RESET',  togglePrinting);

  useEffect(() => {
    setLimit(size);
  }, deps);

  if (search) {
    const tags = useRef();
    tags.current = useNamedSelector('tags.tags');
    const fuse = useMemo(() => new Fuse(list, {
      keys: search.keys.map(name => /\btag\b/.test(name) ? makeTagKey(name, tags) : name),
      threshold: 0.25,
      ignoreLocation: true,
    }), [ ...deps, list ]);
    list = search.q ? fuse.search(search.q).map(item => item.item) : list;
  }

  return [
    list.slice(0, isPrinting ? 1000 : limit),
    () => createElement(Last, { limit, setLimit, max: list.length, size }),
  ];
}

function Last({ limit, setLimit, max, size }) {
  const ref = useRef();
  const intersection = useIntersection(ref, { threshold: 1 });
  useEffect(() => {
    if (intersection && intersection.isIntersecting && limit < max) {
      setLimit(limit + size);
    }
  }, [ intersection ]);
  return (
    <div ref={ref} style={{ transform: 'translateY(-50vh)' }} />
  );
}

function makeTagKey(name, tags) {
  return {
    name,
    getFn: object => {
      const ids = get(object, name.replace('tag', 'tagIds'), '');
      return tags.current.getByIds(ids).map(tag => tag.name).join(' ');
    }
  }
}
